import {
    ChangePasswordRequest,
    ChangePasswordResponse,
    ForgotPasswordRequest,
    ForgotPasswordResponse,
    LoginRequest,
    LoginResponse,
    ResetPasswordRequest,
    ResetPasswordResponse,
} from '../interfaces/loginInterfaces';
import { CTW_API_ENDPOINT } from '../utils';
import applyCaseMiddleware from 'axios-case-converter'
import Axios from 'axios'
// import { instrumentAxiosInstance } from '../monitoring';

const axios = applyCaseMiddleware(
    Axios.create({
        baseURL: CTW_API_ENDPOINT,
        headers: {
            'Content-Type': 'application/json',
        },
    })
)

// instrumentAxiosInstance(axios)


class AuthService {
    /**
     * Login user with username/email and password
     * @param username_or_email - User's username or email
     * @param password - Plain text password (will be encrypted)
     * @returns Login response with user details, organizations, and token
     */
    async login(username_or_email: string, password: string): Promise<LoginResponse> {
        debugger;
        try {
            // Prepare request payload
            const requestData: LoginRequest = {
                username_or_email,
                password,
            };

            // Make login API call
            const response = await axios.post<LoginResponse>(
                '/v2/auth/login',
                requestData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );


            return response.data;
        } catch (error: any) {
            // Handle error
            if (error.response) {
                // Server responded with error
                throw new Error(error.response.data?.meta?.message || 'Login failed');
            } else if (error.request) {
                // Request made but no response
                throw new Error('No response from server. Please check your connection.');
            } else {
                // Something else happened
                throw new Error('An error occurred during login');
            }
        }
    }

    /**
     * Login user with CT token
     * @param token - CT session token
     * @returns Login response with user details and organizations
     */
    async ctLogin(token: string): Promise<any> {
        try {
            const response = await axios.post(
                '/v2/auth/ct-login',
                {},
                {
                    headers: {
                        Authorization: token
                    }
                }
            );
            return response.data;
        } catch (error: any) {
            // Handle error
            if (error.response) {
                // Server responded with error
                throw new Error(error.response.data?.meta?.message || 'CT Login failed');
            } else if (error.request) {
                // Request made but no response
                throw new Error('No response from server. Please check your connection.');
            } else {
                // Something else happened
                throw new Error('An error occurred during CT login');
            }
        }
    }

    async changePassword(data: ChangePasswordRequest): Promise<ChangePasswordResponse> {
        try {
            const token = localStorage.getItem('accessToken');
            const response = await axios.post<ChangePasswordResponse>(
                '/v2/auth/change-password',
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: token ? `Bearer ${token}` : '',
                    },
                }
            );

            return response.data;
        } catch (error: any) {
            if (error.response) {
                throw new Error(error.response.data?.meta?.message || 'Failed to change password');
            } else if (error.request) {
                throw new Error('No response from server. Please check your connection.');
            } else {
                throw new Error('An error occurred while changing password');
            }
        }
    }

    async forgotPassword(data: ForgotPasswordRequest): Promise<ForgotPasswordResponse> {
        try {
            const response = await axios.post<ForgotPasswordResponse>(
                '/v2/auth/forgot-password',
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            return response.data;
        } catch (error: any) {
            if (error.response) {
                throw new Error(error.response.data?.meta?.message || 'Failed to send password reset link');
            } else if (error.request) {
                throw new Error('No response from server. Please check your connection.');
            } else {
                throw new Error('An error occurred while sending password reset link');
            }
        }
    }

    async resetPassword(data: ResetPasswordRequest): Promise<ResetPasswordResponse> {
        try {
            const response = await axios.post<ResetPasswordResponse>(
                '/v2/auth/reset-password',
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            return response.data;
        } catch (error: any) {
            if (error.response) {
                throw new Error(error.response.data?.meta?.message || 'Failed to reset password');
            } else if (error.request) {
                throw new Error('No response from server. Please check your connection.');
            } else {
                throw new Error('An error occurred while resetting password');
            }
        }
    }
}

export default new AuthService();
